import { Button } from 'antd';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';

/**
 * NotesSection Component
 * 
 * Extracts all doctor notes and consultation notes functionality from the appointment details form.
 * Handles note-taking functionality and editing for doctor consultation notes.
 * Maintains all existing notes management features including validation and formatting.
 * 
 * @param {Object} props - Component props
 * @param {Object} props.values - Formik values object containing doctorNotes
 * @param {Object} props.errors - Formik errors object
 * @param {Object} props.touched - Formik touched object
 * @param {Function} props.handleChange - Formik handleChange function
 * @param {Function} props.handleBlur - Formik handleBlur function
 * @param {Function} props.setFieldValue - Formik setFieldValue function
 * @param {boolean} props.IsFilledForm - Whether the form is filled/completed
 */
const NotesSection = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  setFieldValue,
  IsFilledForm,
}) => {
  return (
    <div className="row">
      <div className="col-sm-12">
        <div className="card">
          <div className="card-body p-3">
            <div className="mb-3">
              <h4 style={{ color: '#111827', fontWeight: '700', fontSize: '18px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                <FeatherIcon icon="edit" size="20" style={{ color: '#4f46e5' }} />
                Doctor&apos;s Consultation Notes
              </h4>
            </div>
            {values.doctorNotes.map((note, index) => (
              <div key={index}>
                <textarea
                  rows={10}
                  disabled={IsFilledForm}
                  cols={5}
                  className="form-control my-2"
                  placeholder="Enter consultation notes"
                  value={note}
                  onBlur={e => handleBlur(`doctorNotes[${index}]`)}
                  onChange={e => {
                    const newNotes = [...values.doctorNotes];
                    newNotes[index] = e.target.value;
                    setFieldValue('doctorNotes', newNotes);
                  }}
                />
              </div>
            ))}
            <div className="row">
              <Button
                onClick={() => {
                  setFieldValue('doctorNotes', [...values.doctorNotes, '']);
                }}
                className="col-3 m-3"
                disabled={IsFilledForm}
              >
                Add Notes
              </Button>
              {values.doctorNotes.length > 1 && (
                <Button
                  onClick={() => {
                    const newNotes = [...values.doctorNotes];
                    newNotes.pop();
                    setFieldValue('doctorNotes', newNotes);
                  }}
                  className="col-3 m-3"
                  disabled={IsFilledForm}
                >
                  Remove Last Notes
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotesSection;